'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require('react'));

var TabContext = _react.default.createContext(null);

var _default = TabContext;
exports.default = _default;
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./app/praece-react-bootstrap/lib/TabContext.js